import React, { FunctionComponent, Dispatch } from "react";
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Button
} from "@material-ui/core";
import { connect, ConnectedProps } from "react-redux";
import { addExpansion } from "../../../redux/actions/ExpansionsActions";
import { ExpansionInterface } from "../../../redux/reducers/ExpansionsReducers";
import { MODAL_BUYING_BG } from "../../../constants/colors";

interface actionsType {
  addExpansion: (
    expansionName: string
  ) => (
    dispatch: Dispatch<{
      type: string;
    }>
  ) => void;
}
interface RootState {
  expansion: ExpansionInterface;
}

const actionsReducers: actionsType = {
  addExpansion
};

const mapStateToProps = (state: RootState) => ({
  expansion: state.expansion
});

const connector = connect(mapStateToProps, actionsReducers);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface ModalBuyingExpansionsProps {
  onClose:
    | ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void)
    | undefined;
  open: boolean;
  setIsOpen: Dispatch<React.SetStateAction<boolean>>;
  notBoughtYet: string[];
}

const ModalBuyingExpansions: FunctionComponent<ModalBuyingExpansionsProps &
  PropsFromRedux> = (props) => {
  const NotBoughtSize = props.notBoughtYet.length;
  return (
    <Dialog
      onClose={props.onClose}
      aria-labelledby="simple-dialog-title"
      open={props.open && NotBoughtSize > 0}
    >
      <DialogTitle
        id="simple-dialog-title"
        style={{ backgroundColor: MODAL_BUYING_BG }}
      >
        You haven't bought {NotBoughtSize > 1 ? "these" : "this"} expansion
        {NotBoughtSize > 1 && "s"}
      </DialogTitle>
      <List>
        {props.notBoughtYet.map((expansion: string) => (
          <ListItem button key={expansion}>
            <ListItemText primary={displayNameExpansion(expansion)} />

            <Button
              variant="contained"
              onClick={() => {
                (expansion === "premium1_expansion" ||
                  expansion === "premium2_expansion" ||
                  expansion === "premium3_expansion" ||
                  expansion === "free_expansion") &&
                  props.expansion.info &&
                  !props.expansion.info[expansion] &&
                  props.addExpansion(expansion);
              }}
              color="secondary"
            >
              Buy
            </Button>
          </ListItem>
        ))}

        <ListItem autoFocus button onClick={() => props.setIsOpen(false)}>
          <ListItemText style={{ textAlign: "center" }} primary="Close" />
        </ListItem>
      </List>
    </Dialog>
  );
};

export default connector(ModalBuyingExpansions);

function displayNameExpansion(expansion: string) {
  return expansion
    .split("_")
    .map((value: string) => value[0].toUpperCase() + value.slice(1))
    .join(" ");
}
